// D8.14.2 — Helpers puros de NodeConfigModal.

export const buildMediaUrl = (url) => {
  if (!url) return null;
  if (
    url.startsWith("blob:") ||
    url.startsWith("http://") ||
    url.startsWith("https://")
  ) {
    return url;
  }
  const backend =
    window.WATOOLX_BACKEND_URL || process.env.REACT_APP_BACKEND_URL || window.location.origin;
  return `${backend}${url.startsWith("/") ? url : `/${url}`}`;
};

/**
 * Parsea de forma segura el array de ítems de un content node.
 * Acepta tanto Array como JSON string (por si el backend devuelve string).
 */
export const safeParseItems = (raw) => {
  if (Array.isArray(raw)) return raw;
  if (typeof raw === "string" && raw.trim().startsWith("[")) {
    try {
      return JSON.parse(raw);
    } catch {
      return [];
    }
  }
  return [];
};

// ─────────────────────────────────────────────────────────────────────────────
